export function round(number, decimals = 4) {
    const positions = decimals * 10;
    return Math.round(number * positions) / positions;
}

export function sub(n1, n2) {
    const tens = [10, 100, 1000, 10000, 100000, 1000000];

    const n1String = n1.toString().split(".");
    let n1Decimals = 0;
    if (n1String.length == 2) {
        n1Decimals = n1String[1].length;
    }

    const n2String = n2.toString().split(".");
    let n2Decimals = 0;
    if (n2String.length == 2) {
        n2Decimals = n2String[1].length;
    }

    let max_len = 0;
    let max_val = 0;
    if (n1Decimals > n2Decimals) {
        max_val = tens[n1Decimals - 1];
        max_len = n1Decimals;
    } else {
        max_len = n2Decimals;
        max_val = tens[n2Decimals - 1];
    }

    let result = 0;
    if (max_len == 0) {
        // no hay decimas
        max_val = 1;
        result = n1 - n2;
    } else {
        result = parseFloat(((n1 * max_val - n2 * max_val) / max_val).toFixed(max_len));
    }

    return result;
}
